<template>
	<span
		:class="[
			'rounded-full font-display',
			{
				'bg-green-400 text-green-800': variant === 'green',
				'bg-yellow-400 text-yellow-900': variant === 'yellow',
				'bg-white text-gray-900': variant === 'white',
				'bg-purple-500 text-purple-50': variant === 'brand',
				'bg-gray-700 text-gray-50': variant === 'dark',
				'bg-gray-200 text-gray-600': variant === 'light',

				'text-functional-size-xs sm:text-functional-size-xs px-2.5 py-0.5': size === 'xs',
				'uppercase font-bold text-functional-size-xs sm:text-functional-size-sm px-4 py-0.5': size === 'sm',
				'uppercase font-bold text-functional-size-md px-5 py-0.5': size === 'md',
				'uppercase font-bold text-functional-size-md px-5 py-2': size === 'lg',
			},
		]"
	>
		<slot />
	</span>
</template>

<script lang="ts" setup>
import type { ColorVariantEnum } from '#base/core/enums/ColorVariantEnum';

withDefaults(
	defineProps<{
		variant: ColorVariantEnum;
		size?: 'xs' | 'sm' | 'md' | 'lg';
	}>(),
	{
		size: 'md',
	}
);
</script>
